import { ApolloLink } from "@apollo/client";
export const headersLink = (customHeaders = {}) => new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => {
        const additionalHeaders = {};
        return {
            headers: {
                // Setup header to satisfy CSRF (Cross-Site Request Forgery) prevention in the Apollo Router
                // https://www.apollographql.com/docs/router/configuration/csrf/
                "Apollo-Require-Preflight": "true",
                ...headers,
                ...additionalHeaders,
                ...(customHeaders ? customHeaders : {}),
            },
        };
    });
    return forward(operation);
});
//# sourceMappingURL=headers-link.js.map